import { TaskSkill } from 'src/types';
import { SettingKeys } from 'src/types/settings';
import { SettingsSelect } from 'src/v2/components/LeftSidePanel/components/SettingsSelect';
import styles from './ImageGenModelSelect.module.scss';

interface ImageGenModelSelectProps {
  setImageModelValue?: (value: string) => void;
  imageModelValue?: string;
}

export const ImageGenModelSelect = ({
  setImageModelValue,
  imageModelValue,
}: ImageGenModelSelectProps) => {
  return (
    <div className={styles.root}>
      <span className={styles.title}>Image model</span>
      <label className={styles.label}>
        <span>Select your preferred LLM model for the skill</span>
      </label>

      <SettingsSelect
        settingKey={SettingKeys.IMAGE_PRIMARY_MODEL}
        skill={TaskSkill.IMAGE}
        onChange={setImageModelValue}
        value={imageModelValue}
      />
    </div>
  );
};
